import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from 'app/src/queries/withCount';

const ERRORS = `errors { path, message }`;

const ACCOUNT_CORE_FIELDS = gql`
  fragment AccountCoreFields on Account {
    id
    name
    fullName
    gl
    special
    nextCheckNumber
    hiddenAt
  }
`;

export const ACCOUNT_FIELDS = gql`
  ${ACCOUNT_CORE_FIELDS}
  fragment AccountFields on Account {
    ...AccountCoreFields
    accountGroup {
      id
      name
    }
    parent {
      id
      fullName
    }
  }
`;

export const ACCOUNT = gql`
  ${ACCOUNT_FIELDS}
  query Account($id: ID!) {
    account(id: $id) {
      ...AccountFields
    }
  }
`;

export const ACCOUNTS = gql`
  ${ACCOUNT_FIELDS}
  query Accounts {
    accounts {
      ...AccountFields
    }
    accountGroups {
      value: id
      label: name
    }
  }
`;

const ACCOUNT_ARGUMENTS = `
  $accountGroupId: ID!
  $parentId: ID
  $name: String!
  $gl: String
  $special: String
  $nextCheckNumber: Int
`;

const ACCOUNT_VARIABLES = `
  accountGroupId: $accountGroupId
  parentId: $parentId
  name: $name
  gl: $gl
  special: $special
  nextCheckNumber: $nextCheckNumber
`;

export const CREATE_ACCOUNT = gql`
  ${ACCOUNT_CORE_FIELDS}
  mutation CreateAccount (
    ${ACCOUNT_ARGUMENTS}
  ) {
    createAccount (
      ${ACCOUNT_VARIABLES}
    ) {
      account {
        ...AccountCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_ACCOUNT = gql`
  ${ACCOUNT_CORE_FIELDS}
  mutation UpdateAccount (
    $id: ID!
    ${ACCOUNT_ARGUMENTS}
  ) {
    updateAccount (
      id: $id
      ${ACCOUNT_VARIABLES}
    ) {
      account {
        ...AccountCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const HIDE_ACCOUNT = gql`
  ${ACCOUNT_CORE_FIELDS}
  mutation HideAccount ($id: ID!) {
    hideAccount (id: $id) {
      account {
        ...AccountCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UNHIDE_ACCOUNT = gql`
  ${ACCOUNT_CORE_FIELDS}
  mutation UnhideAccount ($id: ID!) {
    unhideAccount (id: $id) {
      account {
        ...AccountCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const ACCOUNTS_WITH_COUNT = gql`
  ${ACCOUNT_FIELDS}
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    accountsWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ...AccountFields
      }
      accountGroups {
        value: id
        label: name
      }
      specialTypes
      count
    }
  }
`;
